// @ts-nocheck
import * as React from "react";

import ModalInfo from "../modalInfo";
import CardDrawWinner from "../CardDrawWinner";

// Components
import Loader from "../Loader";

const THEMEURL = window.drupalSettings
  ? window.drupalSettings.path.themeUrl
  : "themes/custom/mx_aguas_firmes_theme";
enum TypeCardDraw {
  default,
  large,
}

export const Landing = ({ setLoading, loading, data }: ComponentArticles) => {
    const urlFlagNewUser = new URL(location.href)?.searchParams?.get("newUser");
    const urlFlagActivateUser = new URL(location.href)?.searchParams?.get("userActivated");
  React.useEffect(() => {
    window.onload = function () {
      setLoading(false);
    };
  }, []);

  return (
    <main className="landing">
      <ModalInfo
        title={"¡Gracias por sumarte!"}
        subtitle={"Revisa tu correo electrónico"}
        desc={
          "Hemos enviado un correo para confirmar tu cuenta. Si no lo encuentras en tu bandeja de entrada revisa en la carpeta de spam o correo no deseado."
        }
        validation={urlFlagNewUser == "true"}
      />
      <ModalInfo
        title={"¡Todo está listo!"}
        subtitle={"Confirmación exitosa"}
        desc={
          "Puedes inscribir a un niño/a para que participe con su dibujo o votar por los que más te gusten "
        }
        confirmation={urlFlagActivateUser == "true"}
      />
      <div className="landing__content">
        <div className="landing__content__banner">
          <picture className="landing__content__banner--img">
            <source
              srcSet={`/${THEMEURL}/sources/dist/assets/images/landing/bannerLanding.png`}
              media="(min-width: 991px)"
            ></source>
            <img
              src={`/${THEMEURL}/sources/dist/assets/images/landing/bannerMob.svg`}
              alt="MDN"
            ></img>
          </picture>
          <div className="landing__content__banner--info">
            <h1 className="title--banner">{data.field_title}</h1>
            <div className="info-banner">
              <div className="info-banner--icon">
                <img src={data.field_img.url} alt={data.field_img.alt}></img>
              </div>
              <div className="info-banner--wrapper">
                <h2 className="info-banner--title">{data.field_subtitle}</h2>
                <div className="info-banner--winners">
                  <CardDrawWinner 
                    title="Niños esperanza de vida para el futuro."
                    category="INFANTIL 6-8 años"
                    school="Escuela Olimpiada 1968"
                    place="Calera"
                    image="https://aguasfirmes.s3.amazonaws.com/dibujos/file_IMG-20220420-WA00271650504307.jpg"
                  />
                  <CardDrawWinner
                    title="Si acuíferos queremos salvar, árboles debemos plantar y el agua de lluvia reciclar"
                    category="Junior"
                    school="Escuela Manuel Sabino Crespo"
                    place="Calera"
                    image="https://aguasfirmes.s3.amazonaws.com/dibujos/file_IMG_20220508_1906141652637229.jpg"
                  />
                </div>
                <div className="info-banner--text">
                  <div dangerouslySetInnerHTML={{ __html: data.field_desc }}></div>
                  <div className="info-banner--text-btns">
                    {/* <a href={data.field_btn_banner1.url} className="btnParticipa">
                      {data.field_btn_banner1.title}
                    </a> */}
                    <a href={data.field_btn_banner2.url} className="btnVotar">
                      {data.field_btn_banner2.title}
                    </a>
                    <a href="/ranking" className="btnParticipa hidden">
                      Ver ranking
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Loader(Landing);
